import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md-typescale-body-large description" }

import OTPInputForm from '@/features/SmsCodeVerification/components/OTPInputForm/OTPInputForm.vue';
import SendOtpForm from '@/features/SmsCodeVerification/components/SendOtpForm/SendOtpForm.vue';
import Flex from '@/components/Flex/Flex.vue';
import { useI18n } from 'vue-i18n';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Logo from '@/components/Logo/Logo.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SmsCodeVerification',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const otpSent = ref(false);

const addPlusPrefixAndRemoveSpace = (value: string) => {
  const valueWithoutSpace = value.replaceAll(' ', '');

  return valueWithoutSpace[0] === '+'
    ? valueWithoutSpace
    : `+${valueWithoutSpace}`;
};

onMounted(async () => {
  const usersPhone = route.query.phoneNumber as string;

  if (!usersPhone) {
    await router.push('/sign-in');

    return;
  }
});

const usersPhoneNumber = computed(() => {
  const { phoneNumber } = route.query;
  let finalPhoneNumber = phoneNumber || '';

  if (Array.isArray(finalPhoneNumber)) {
    finalPhoneNumber = finalPhoneNumber[0] as string;
  }

  return addPlusPrefixAndRemoveSpace(finalPhoneNumber);
});

const successHandler = () => {
  otpSent.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Flex, {
    class: "wrapper",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(Flex, {
        gap: 5,
        direction: "column",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(Flex, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(Logo, {
                width: 112,
                height: 112
              })
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('sign_in.description', { phoneNumber: usersPhoneNumber.value })), 1),
          _createVNode(SendOtpForm, {
            usersPhone: usersPhoneNumber.value,
            onSuccess: successHandler,
            onExpired: _cache[0] || (_cache[0] = ($event: any) => (otpSent.value = false))
          }, null, 8, ["usersPhone"]),
          _createVNode(Flex, null, {
            default: _withCtx(() => [
              _createVNode(OTPInputForm, {
                usersPhone: usersPhoneNumber.value,
                otpSent: otpSent.value
              }, null, 8, ["usersPhone", "otpSent"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})